import { useQuery } from "@tanstack/react-query";
import { offerGet } from "@/api_client";
import { getOfferQueryKey } from "@/hooks/api/offer/offerQueryKey";

export const useOffer = (enabled: boolean = true) => {
  return useQuery({
    enabled,
    queryKey: getOfferQueryKey(),
    queryFn: async () => (await offerGet()).data,
    placeholderData: (prev) => prev,
  });
};
